import { DeliveredOrdersType } from 'b2b-common/core/account/api/DeliveredOrders.types';
import {
  CLEAR_ACCOUNT_DELIVERED_ORDERS,
  FETCH_DELIVERED_ORDERS,
  FETCH_DELIVERED_ORDERS_FULFILLED,
  FETCH_DELIVERED_ORDERS_REJECTED,
} from './actionTypes';
import {
  ClearAccountDeliveredOrdersAction,
  FetchDeliveredOrdersAction,
  FetchDeliveredOrdersFulfilledAction,
  FetchDeliveredOrdersRejectedAction,
} from './types';

const fetchDeliveredOrders = (startItem: number): FetchDeliveredOrdersAction => ({
  type: FETCH_DELIVERED_ORDERS,
  payload: {
    startItem,
  },
});

const fetchDeliveredOrdersFulfilled = (response: DeliveredOrdersType): FetchDeliveredOrdersFulfilledAction => ({
  type: FETCH_DELIVERED_ORDERS_FULFILLED,
  payload: {
    data: response,
  },
});

const fetchDeliveredOrdersRejected = (error: ErrorType): FetchDeliveredOrdersRejectedAction => ({
  type: FETCH_DELIVERED_ORDERS_REJECTED,
  payload: {
    error,
  },
});

const clearAccountDeliveredOrders = (): ClearAccountDeliveredOrdersAction => ({
  type: CLEAR_ACCOUNT_DELIVERED_ORDERS,
});

export {
  clearAccountDeliveredOrders,
  fetchDeliveredOrders,
  fetchDeliveredOrdersFulfilled,
  fetchDeliveredOrdersRejected,
};
